import { verifyFullyAnsweredQuestionState } from './verify-fully-answered-question-state';
import { SectionKey, QuestionsBySectionMap } from 'types';

type CreateSectionsStateParams = {
  sectionOrder: SectionKey[];
  questionsBySectionMap: QuestionsBySectionMap[];
  answerState: PvWizardResultsQueryVariables;
};

type SectionState = {
  sectionName: SectionKey;
  sectionOrderIndex: number;
  questionsOfSection: string[];
  missingQuestions: string[];
};

type CreateAnswerStateParams = {
  sectionState: SectionState[];
  answerState: PvWizardResultsQueryVariables;
};

type ExtendedSectionState = SectionState & {
  isCurrentSectionAnswered: boolean;
  isPreviousSectionAnswered: boolean;
};

export const getCurrentSlide = (answeredSectionState: ExtendedSectionState[]) =>
  answeredSectionState.find(
    section =>
      (!section.isCurrentSectionAnswered && section.isPreviousSectionAnswered) ||
      (section.sectionName === 'solarStorage' && section.isPreviousSectionAnswered)
  );

export const getQuestionBySectionMap = (
  sectionOrder: SectionKey[],
  sectionData: PvWizardSections
): QuestionsBySectionMap[] =>
  sectionOrder.map(order => {
    const key = order;
    const values = sectionData[order].questions.map(question => question.key);
    return { [key as SectionKey]: values };
  });

export const getSectionsState = ({
  sectionOrder,
  questionsBySectionMap,
  answerState
}: CreateSectionsStateParams): SectionState[] => {
  const initialAnswerKeys = Object.keys(answerState);

  return sectionOrder.map((sectionKey, index) => {
    const questionsOfSection = questionsBySectionMap[index][sectionKey];
    const missingQuestions = questionsOfSection.filter(
      question => !initialAnswerKeys.includes(question)
    );

    return {
      sectionName: sectionKey,
      sectionOrderIndex: index,
      questionsOfSection,
      missingQuestions
    };
  });
};

export const getAnswerSectionState = ({
  sectionState,
  answerState
}: CreateAnswerStateParams): ExtendedSectionState[] => {
  const answeredSections = sectionState.map((section, index) => {
    const isPreviousSectionAnswered =
      index === 0
        ? true
        : verifyFullyAnsweredQuestionState({
            answerState,
            section: sectionState[index - 1]
          });

    const isCurrentSectionAnswered = verifyFullyAnsweredQuestionState({
      answerState,
      section
    });

    return {
      ...section,
      isCurrentSectionAnswered,
      isPreviousSectionAnswered
    };
  });

  return answeredSections;
};
